import { render, staticRenderFns } from "./UserActivityTally.vue?vue&type=template&id=7d858935&"
import script from "./UserActivityTally.vue?vue&type=script&lang=js&"
export * from "./UserActivityTally.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports